// PageSlug allows "/" for nested paths (e.g. "products/shoe"), unlike TenantSlug/Subdomain.
// "blog" is reserved: apps/sites/src/App.tsx hardcodes /blog and /blog/:slug ahead of the
// dynamic per-page route map, so a page slugged "blog" would be silently unreachable —
// shadowed by the blog index route, no error, the page just never renders.
export class PageSlug {
  private constructor(private readonly value: string) {}

  static from(raw: string): PageSlug {
    const normalised = raw
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-/]/g, '')
      .replace(/-+/g, '-')
      .replace(/\/+/g, '/')
      .replace(/^\/|\/$/g, '') // strip leading/trailing slashes

    if (!normalised) throw new Error('Page slug cannot be empty')
    if (normalised.length > 128) throw new Error('Page slug must be at most 128 characters')
    if (normalised === 'blog' || normalised.startsWith('blog/')) {
      throw new Error('"blog" is a reserved page path')
    }

    return new PageSlug(normalised)
  }

  toString(): string { return this.value }
  equals(other: PageSlug): boolean { return this.value === other.value }
  isHome(): boolean { return this.value === 'home' }
}
